import { PRODUCT_MODE_CODES } from 'constants/Constants';

/** True when product mode is a Sage implementation (e.g. sage, sage_starter). */
export function isSageImplementation(productModeCode) {
    return typeof productModeCode === 'string' && productModeCode.includes(PRODUCT_MODE_CODES.SAGE);
}
